import moment from 'moment'
import _ from 'lodash'

function valueFallbackComparer (originalValue, newValue) {
  if (typeof originalValue !== 'object' && typeof newValue !== 'object') {
    return originalValue === newValue
  }
  // Handle null and undefined comparison
  if (typeof originalValue === 'undefined') {
    return typeof newValue === 'undefined' || newValue === null
  }
  if (typeof newValue === 'undefined') {
    return typeof originalValue === 'undefined' || originalValue === null
  }
  if (originalValue === null) {
    return newValue === null
  }
  if (newValue === null) {
    return false
  }

  if ((moment.isMoment(originalValue) && moment.isMoment(newValue)) || (moment.isDate(originalValue) && moment.isDate(newValue))) {
    const comparisonValue = moment.isMoment(originalValue) ? originalValue : moment(originalValue)
    return comparisonValue.isSame(newValue)
  }
  if (originalValue.id !== undefined && newValue.id !== undefined) {
    return originalValue.id === newValue.id
  }
  if (originalValue.name !== undefined && newValue.name !== undefined) {
    return originalValue.name === newValue.name
  }
  if (originalValue.code !== undefined && newValue.code !== undefined) {
    return originalValue.code === newValue.code
  }
  return _.isEqual(originalValue, newValue)
}

export default valueFallbackComparer



// WEBPACK FOOTER //
// ./src/utils/valueComparer.js